import React, {useEffect, useState} from 'react'
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import PropTypes from 'prop-types';
import TextField from '@material-ui/core/TextField';
import Tooltip from '@material-ui/core/Tooltip';
import UserService from '../../../../services/UserService'
import {ToastContainer, toast} from "react-toastify";
import "react-toastify/dist/ReactToastify.css";


const initialUser = {
    //
    firstName: '',
    lastName: '',
    email: '',
    username: '',
    role: ''
}

const AddUserDialog = props => {
    const [user, setUser] = useState(initialUser)
    const [roles, setRoles] = useState([]);
    const {addUserHandler} = props
    const [open, setOpen] = React.useState(false)

    const [switchState, setSwitchState] = React.useState({
        addMultiple: false,
    })

    const handleSwitchChange = name => event => {
        setSwitchState({ ...switchState, [name]: event.target.checked })
    }

    const resetSwitch = () => {
        setSwitchState({ addMultiple: false })
    }

    const handleClickOpen = () => {
        setOpen(true)
    }

    const handleClose = () => {
        setOpen(false)
        resetSwitch()
    }

    const handleAdd = event => {
        addUserHandler(user)
        setUser(initialUser)
        switchState.addMultiple ? setOpen(true) : setOpen(false)
    }

    const handleChange = name => ({target: {value}}) => {
        setUser({...user, [name]: value})
    }

    const [password, setPassword] = useState("********");

    const generatePassword = () => {
        // Create a random password
        const randomPassword =
            Math.random().toString(36).slice(2);

        // Set the generated password as state
        setPassword(randomPassword);
        setUser({...user, 'password': randomPassword});

        // copy the password to the clipboard & fire toast message
        if (navigator.clipboard.writeText(randomPassword)) {
            toast("Password copied to your clipboard");
        }
    };

    useEffect(() => {
        UserService.getAllRoles()
            .then(res => {
                console.log(res.data);
                let d = [];
                res.data.data.map((roles, i) => {
                    console.log("no. ", i, "role: ", roles[0])
                    d.push(roles[0])
                })
                setRoles(d)
            })
            .catch(err => {
                console.log(err);
                setRoles([])
            });
    }, []);

    return (
        <div>

            <Tooltip title="Add New">
                <span className="btn btn-sm btn-primary mr-5" onClick={handleClickOpen}>
                    <i className="fa fa-plus-square"/> &nbsp;&nbsp;Add User
                </span>
            </Tooltip>
            <Dialog
                open={open}
                onClose={handleClose}
                aria-labelledby="form-dialog-title"
            >
                <DialogTitle id="form-dialog-title">Create Account</DialogTitle>
                <DialogContent>
                    <DialogContentText>Please fill in details</DialogContentText>
                    <div className="row">
                        <div className="col-4">
                            <TextField
                                autoFocus
                                margin="dense"
                                label="First Name"
                                type="text"
                                fullWidth
                        value={user.firstName}
                        onChange={handleChange('firstName')}
                    />
                        </div>
                        <div className="col-4">
                        <TextField
                            margin="dense"
                            label="Surname"
                            type="text"
                            fullWidth
                            value={user.lastName}
                            onChange={handleChange('lastName')}
                        />

                        </div>
                        <div className="col-4">
                            <TextField
                                margin="dense"
                                label="Email"
                                type="text"
                                fullWidth
                                value={user.email}
                                onChange={handleChange('email')}
                            />
                        </div>

                    </div>
                    <div className="row mb-2 mt-2">

                        <div className="col-6">
                            <select
                                name="role"
                                id="role"
                                className="form-control"
                                onChange={handleChange('role')}>
                                <option selected disabled>Select Basic Role</option>
                                {roles.map((a, i) => {
                                    if (a.name !== 'sysadmin') {
                                        return (
                                            <option key={i} value={parseInt(a.id)}>{a.name}</option>
                                        )
                                    }

                                })}
                            </select>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-md-8">
                            <TextField
                                margin="dense"
                                type="text"
                                fullWidth
                                value={password}
                                disabled={true}
                                style={{backgroundColor: "#f6f4f4"}}
                            />
                        </div>
                        <div className="col-md-4">
                            <button onClick={generatePassword} className="btn btn-sm btn-dark">
                                Generate Password
                            </button>
                        </div>

                    </div>
                    {/* adding toast container so that we can showcase the message */}
                    <ToastContainer/>

                </DialogContent>
                <DialogActions>

                    <Button onClick={handleClose} color="primary">
                        Cancel
                    </Button>
                    <Button onClick={handleAdd} color="primary">
                        Create Account
                    </Button>
                </DialogActions>
            </Dialog>
        </div>
    )
}

AddUserDialog.propTypes = {
    addUserHandler: PropTypes.func.isRequired,
}

export default AddUserDialog;
